<template>
  <div class="schedule-button" @click.stop="() => {}">
    <font-awesome-icon v-if="isSubmitting" icon="spinner-third" class="text-hint" spin />
    <template v-else>

      <template v-if="!referral.is_marked_scheduled">
        <button type="button" title="Schedule Referral" class="btn btn-outline-primary d-none d-md-inline" @click="mark_scheduled">
          <span class="d-none d-md-inline">Mark&nbsp;</span>schedule<span class="d-none d-md-inline">d</span>
        </button>
      </template>
      <VueCtkDateTimePicker v-else @is-hidden="checkNow" v-model="appointment_time" :noClearButton="false" :no-value-to-custom-elem="true" :no-button-now="!(allowDelete && referral.scheduled_time)" :button-now-translation="' '" :min-date="moment(referral.sent_time).subtract(1, 'days').toISOString()" name="scheduled_time" color="#519F85" minute-interval="5" data-vv-as="Appointment Time" class="schedule-picker" :position="position" @validate="submit">

        <template #default>
          <slot>
            <button type="button" title="Schedule Referral" class="btn btn-outline-primary d-none d-md-inline">
              Set<span class="d-none d-lg-inline">&nbsp;appointment</span>
            </button>
            <button type="button" title="Schedule Referral" class="btn btn-link d-md-none">
              <font-awesome-icon :icon="['far', 'calendar']" class="mr-2" />
            </button>

            <button title="Remove appointment" class="btn btn-link">
              Delete<span class="d-none d-lg-inline">&nbsp;appointment</span>
            </button>
          </slot>
        </template>
      </VueCtkDateTimePicker>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  props: {
    referral: Object,
    position: { type: String, default: null },
    allowDelete: { type: Boolean, default: false },
  },
  components: { VueCtkDateTimePicker },
  async created() {},
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      scheduled_time: null,
    }
  },
  computed: {
    appointment_time: {
      get: function () {
        const t = this.scheduled_time || null
        return t
      },
      set: function (v) {
        this.scheduled_time = v
      },
    },
  },
  methods: {
    async mark_scheduled() {
      this.isSubmitting = true
      await this.$store.dispatch('referrals/save', {
        ...this.referral,
        is_marked_scheduled: true,
      })
      this.isSubmitting = false
    },
    async submit() {
      const updatedReferral = {
        ...this.referral,
        scheduled_time: moment(this.scheduled_time).utc().toISOString(),
      }

      const isValid = await this.$validator.validate('schedule-form.*')
      if (!isValid) return
      this.isSubmitting = true
      //const savedReferral = await ReferralApi.save(updatedReferral);
      await this.$store.dispatch('referrals/save', updatedReferral)
      this.isSubmitting = false
      this.$emit('scheduled')
    },
    checkNow() {
      //hack: starting to loathe this plugin. This is a hacky way to allow
      //unscheduling within the modal. should just be a custom modal
      const isNowish =
        Math.abs(moment().diff(this.scheduled_time, 'minutes')) < 3
      if (isNowish) {
        this.scheduled_time = null
        this.submit()
      }
    },
  },
}
</script>
<style>
.vdp-datepicker input.form-control[readonly] {
  background-color: unset;
}
.schedule-button .datetimepicker {
  left: -400px;
}
</style>
